import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clubCapraboBloque from '../../../assets/images/club-caprabo-bloque.png';
import useSessionChecking from '../../../hooks/useSessionChecking';
import { useAppStore } from '../../../store/AppContext';
import { useAuthStore } from '../../../store/AuthContext';
import { BackMappings } from '../../../utils/BackMappings';
import { CookieHelper } from '../../../utils/CookieHelper';
import { HostProvider } from '../../../utils/HostProvider';
import { StorageHelper } from '../../../utils/StorageHelper';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import routerLoader from '../../../i18n/router';
import { useMisDatosStore } from '../../MisDatos/context/MisDatos.context';
import DataService from '../../../services/MisDatosService';

const NoTitularCaprabo: FC = () => {
  const { t } = useTranslation();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const [messageError, setMessageError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [responseValidation, setResponseValidation] = useState<any>();
  const { showModalContactEmail, hideModalV2P } = useMisDatosStore();

  const handleSolicitarSocioClub = (e) => {
    DataService.checkPrevalidacionDatosAltaClub()
      .then((responsePrevalidacion) => {
        if (responsePrevalidacion.data.error) {
          setMessageError(
            t('tarjetas.tarjeta-socio.error-AME-prevalidation-message-caprabo'),
          );
          setResponseValidation(responsePrevalidacion);
          setShowModal(true);
        } else {
          e.stopPropagation();
          e.preventDefault();
          StorageHelper.deleteUserFromSession();
          CookieHelper.removeUserCookies();
          document.location.href = `${HostProvider.getHost()}${
            dataApp.lang
          }/nlrRegistrar/noTitular/tarjetas?fromApp=${
            dataUser.user.fromApp
          }&origenAP=tarjetas`;
        }
      })
      .catch((er: any) => {
        console.log(er);
        setMessageError(t('nlr-vaya-algo-no-ha-ido-bien'));
        setShowModal(true);
      });
  };

  const gotoMisdatos = () => {
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
    ) {
      StorageHelper.setOpenV2PFromOro();
      StorageHelper.setOpenDireccionHabitual();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
    ) {
      StorageHelper.setOpenV2PFromOro();
      StorageHelper.setOpenOroPersonalData();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
    ) {
      StorageHelper.setOpenV2PFromOro();
      StorageHelper.setOpenOroPersonalData();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
    ) {
      StorageHelper.setOpenTelefonoError();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
    ) {
      showModalContactEmail();
    }
    hideModalV2P();
    window.location.href = routerLoader.LoadRouterByPath(
      'mis-datos',
      dataApp.lang,
    );
  };
  if (goOn) {
    return (
      <>
        <section className="section header-tarjetas header-tarjetas__large tarjetas">
          <div className="container-inner">
            <div className="header-tarjetas__content">
              <h1 className="header-tarjetas__title">
                {t('tarjetas.sin-tarjeta.title')}
              </h1>
              <p
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: t('tarjetas.sin-tarjeta.advantages-card'),
                }}
              />
            </div>

            <ul className="header-tarjetas__lista u-text-white u-margin-top-giant-desktop">
              <li>{t('caprabo.tarjetas.hero-line-one')}</li>
              <li>{t('caprabo.tarjetas.hero-line-two')}</li>
              <li>{t('caprabo.tarjetas.hero-line-three')}</li>
            </ul>

            <div className="bloque-action__tarjeta">
              <p>{t('tarjetas.sin-tarjeta.request-it')}</p>
              <div className="img img-tarjeta_small">
                <img src={clubCapraboBloque} alt="Tarjeta Club" />
              </div>
              <p className="bloque-action__title">
                {t('caprabo.tarjetas.make-partner')}
              </p>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                className="btn btn-default"
                onClick={handleSolicitarSocioClub}
              >
                {t('tarjetas.sin-tarjeta.request-be-partner')}
              </a>
            </div>
          </div>
        </section>
        <section className="o-section--giant__top u-padding-bottom-hero section--background-img tarjetas">
          <div className="container-inner">
            <div className="u-display-flex-desktop u-justify-content-space-between u-align-items-start">
              <div className="tarjeta__content">
                <h2 className="bloque-datos__title">
                  <span className="divider__square brand-color" />
                  <span className="u-margin-right">
                    {t('caprabo.tarjetas.other-advantages')}
                  </span>
                </h2>

                <ul className="header-tarjetas__lista">
                  <li
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: t('tarjetas.sin-tarjeta.month-save'),
                    }}
                  />
                  <li
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: t('tarjetas.sin-tarjeta.digital-ticket'),
                    }}
                  />
                  <li
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: t('tarjetas.sin-tarjeta.shop-and-tickets'),
                    }}
                  />
                </ul>
              </div>
            </div>
          </div>
        </section>{' '}
        <ModalConfirmacion
          isBig={false}
          isSmall
          textCentered
          showModal={showModal}
          setShowModal={setShowModal}
          title=""
          textHTMLContent={t(messageError)}
          doAceptar={gotoMisdatos}
          doClose={() => setShowModal(false)}
          showCancel={false}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
      </>
    );
  }
  return <></>;
};

export default NoTitularCaprabo;
